import { FormsModule }           from '@angular/forms';
import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { AreaChartComponent }        from './charts/intelligence.area-chart.component';
import { BarChartComponent }         from './charts/intelligence.bar-chart.component';
import { ChartCardComponent }        from './charts/intelligence.chart-card.component';
import { ChartTooltipComponent }     from './charts/intelligence.chart-tooltip.component';
import { CustomersTabComponent }     from './tabs/intelligence.customers-tab.component';
import { DateRangePickerComponent }  from './intelligence.date-range-picker.component';
import { DealershipTabComponent }    from './tabs/intelligence.dealership-tab.component';
import { FilterComponent }           from './intelligence.filter.component';
import { DonutChartComponent }       from './charts/intelligence.donut-chart.component';
import { HbarChartComponent }        from './charts/intelligence.hbar-chart.component';
import { InspectionsTabComponent }   from './tabs/intelligence.inspections-tab.component';
import { IntelligenceComponent }     from './intelligence.component';
import { IntelligenceStates }        from './intelligence.states';
import { KpiCardComponent }          from './charts/intelligence.kpi-card.component';
import { MechanicsTabComponent }     from './tabs/intelligence.mechanics-tab.component';
import { MoneyTabComponent }         from './tabs/intelligence.money-tab.component';
import { OperationsTabComponent }    from './tabs/intelligence.operations-tab.component';
import { OpportunitiesTabComponent } from './tabs/intelligence.opportunities-tab.component';
import { OverviewTabComponent }      from './tabs/intelligence.overview-tab.component';
import { ProductsTabComponent }      from './tabs/intelligence.products-tab.component';
import { PurchasingTabComponent }    from './tabs/intelligence.purchasing-tab.component';
import { SharedModule }              from '../shared/shared.module';
import { SortHeaderComponent }       from './charts/intelligence.sort-header.component';
import { VehiclesTabComponent }      from './tabs/intelligence.vehicles-tab.component';

@NgModule({
  declarations: [
    AreaChartComponent,
    BarChartComponent,
    ChartCardComponent,
    ChartTooltipComponent,
    CustomersTabComponent,
    DateRangePickerComponent,
    DealershipTabComponent,
    FilterComponent,
    DonutChartComponent,
    HbarChartComponent,
    InspectionsTabComponent,
    IntelligenceComponent,
    KpiCardComponent,
    MechanicsTabComponent,
    MoneyTabComponent,
    OperationsTabComponent,
    OpportunitiesTabComponent,
    OverviewTabComponent,
    ProductsTabComponent,
    PurchasingTabComponent,
    SortHeaderComponent,
    VehiclesTabComponent
  ],
  entryComponents: [
    IntelligenceComponent
  ],
  imports: [
    FormsModule,
    SharedModule,

    UIRouterUpgradeModule.forChild({ states: IntelligenceStates })
  ]
})
export class IntelligenceModule {}
